import React from 'react';
import { ProductTypeOptions } from '@shopify-multiseller/graphql/partner/types';
import { SectionCard } from '../../../components/SectionCard';
import { useSettings } from '../../../hooks';
import { ProductTypeField } from './ProductTypeField';

export interface ProductTypeSectionProps {
  disabled?: boolean;
  setTrackQuantity: (_value: boolean) => void;
}

/**
 * What kind of thing is being sold.
 *
 * It sat at the top of "Pricing & inventory", where the design draws it, but it
 * is not a pricing question — it decides whether the product ships, whether
 * stock is tracked at all, and whether the shipping section exists. Everything
 * below it follows from it, so it reads as its own decision rather than as the
 * first field of the next one.
 *
 * Renders nothing when the shop's settings fix the type: the field itself
 * returns null in that case, and a panel with an empty body is worse than no
 * panel.
 */
export const ProductTypeSection: React.FC<ProductTypeSectionProps> = ({
  disabled,
  setTrackQuantity,
}) => {
  const settings = useSettings();
  if (settings.productType?.productType !== ProductTypeOptions.Both) {
    // The field draws nothing when the shop has fixed the type, but it is what
    // applies that type to the form — so it stays mounted, just not in a panel
    // whose body would be empty.
    return <ProductTypeField disabled={disabled} setTrackQuantity={setTrackQuantity} />;
  }

  return (
    <SectionCard title="Product type" testId="product-type-section">
      <ProductTypeField disabled={disabled} setTrackQuantity={setTrackQuantity} hideLabel />
    </SectionCard>
  );
};
